import { render, staticRenderFns } from "./ClinicInformation.vue?vue&type=template&id=b2f66c42&scoped=true&"
import script from "./ClinicInformation.vue?vue&type=script&lang=js&"
export * from "./ClinicInformation.vue?vue&type=script&lang=js&"
import style0 from "./ClinicInformation.vue?vue&type=style&index=0&id=b2f66c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f66c42",
  null
  
)

export default component.exports